import { combineReducers } from 'redux';
import course from './course.reducer';

export default combineReducers({
  course
});
